import { render } from "./DefaultStatisticsCard.vue?vue&type=template&id=220253ed"
import script from "./DefaultStatisticsCard.vue?vue&type=script&lang=js"
export * from "./DefaultStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__